import { render, staticRenderFns } from "./SettingsCheckbox.vue?vue&type=template&id=a77a0732"
import script from "./SettingsCheckbox.vue?vue&type=script&lang=js"
export * from "./SettingsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports